

import React, { useState, useEffect } from "react";
import videoService from "../services/videoService";




// Composant pour suggérer automatiquement 3 vidéos Pixabay pertinentes
function PixabaySuggestions({ theme, onSelect }) {
  const [videos, setVideos] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    let mounted = true;
    setLoading(true);
    videoService.searchPixabayVideos(theme, 3).then(vs => {
      if (mounted) {
        setVideos(vs.slice(0, 3));
        if (onSelect && vs.length >= 3) onSelect(vs.slice(0, 3).map(v => v.url));
      }
      if (mounted) setLoading(false);
    }).catch(() => setLoading(false));
    return () => { mounted = false; };
  }, [theme, onSelect]);
  if (loading) return <div className="text-gray-400">Chargement des suggestions vidéo…</div>;
  if (!videos.length) return <div className="text-gray-400">Aucune vidéo pertinente trouvée.</div>;
  return (
    <div className="mt-4">
      <div className="font-semibold mb-2">Vidéos suggérées :</div>
      <div className="grid grid-cols-3 gap-2">
        {videos.map((vid, idx) => (
          <video key={vid.url} src={vid.preview} controls className="w-full h-32 object-cover rounded">
            <track kind="captions" />
          </video>
        ))}
      </div>
    </div>
  );
}

const Monia = () => { 
  const [prompt, setPrompt] = useState("");
  const [videoUrl, setVideoUrl] = useState(null);
  const [description, setDescription] = useState("");
  const [tags, setTags] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  // Code supprimé car inutilisé

  const [copiedDesc, setCopiedDesc] = useState(false);
  const [copiedTag, setCopiedTag] = useState(null);
  const [history, setHistory] = useState([]);
  const [loadingHistory, setLoadingHistory] = useState(false);
  const [copiedHistory, setCopiedHistory] = useState({});
  const [subject, setSubject] = useState("");
  const [tiktokTitle, setTiktokTitle] = useState("");
  const [gptPrompt, setGptPrompt] = useState("");

  // Fonctions utilitaires pour réduire la profondeur d’imbrication
  const handleCopyDesc = (id, description) => {
    navigator.clipboard.writeText(description);
    setCopiedHistory((prev) => ({ ...prev, [id + '-desc']: true }));
    setTimeout(() => setCopiedHistory((prev) => ({ ...prev, [id + '-desc']: false })), 1200);
  };

  const handleCopyTag = (id, tag) => {
    navigator.clipboard.writeText(tag);
    setCopiedHistory((prev) => ({ ...prev, [id + '-tag-' + tag]: true }));
    setTimeout(() => setCopiedHistory((prev) => ({ ...prev, [id + '-tag-' + tag]: false })), 1200);
  };
  // Charger l’historique au chargement du composant
  const fetchHistory = async () => {
    setLoadingHistory(true);
    try {
      const data = await videoService.getHistory();
      setHistory(data);
    } finally {
      setLoadingHistory(false);
    }
  };
  useEffect(() => {
    fetchHistory();
  }, []);

  // Nouveau workflow : prompt → script → sélection vidéos → génération vidéo
  const [step, setStep] = useState('prompt'); // prompt | script | select | result
  const [script, setScript] = useState('');
  const [pixabayVideos, setPixabayVideos] = useState([]);
  const [selectedVideos, setSelectedVideos] = useState([]);

  const handleChange = (e) => setPrompt(e.target.value);

  // 1. Générer le script à partir du prompt
  const handlePromptSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");
    setScript('');
    setTags([]);
    setSubject("");
    setTiktokTitle("");
    setGptPrompt("");
    try {
      const { script, tags, subject } = await videoService.generateScript(prompt);
      setScript(script);
      setTags(tags);
      setSubject(subject || "");
      // Générer un titre TikTok viral (simple heuristique)
      let title = subject ? `🔥 ${subject} : ce que tu ignores !` : "Découvre ce fait incroyable !";
      setTiktokTitle(title);
      // Préparer le prompt pour ChatGPT
      const chatPrompt = `Rédige-moi un script TikTok court, fun, sans répétition, avec un hook d'intro, un titre viral, et une conclusion engageante. Le style doit être dynamique, donner envie d'écouter jusqu'au bout. Utilise ce contenu comme base :\n\n${script}`;
      setGptPrompt(chatPrompt);
      setStep('script');
    } catch (err) {
      setError("Erreur lors de la génération du script.\n" + (err?.message || ''));
    } finally {
      setIsLoading(false);
    }
  };

  // 2. Chercher des vidéos Pixabay en fonction du prompt
  const handleScriptConfirm = async () => {
    setIsLoading(true);
    setError("");
    setPixabayVideos([]);
    setSelectedVideos([]);
    try {
      const videos = await videoService.searchPixabayVideos(prompt, 6);
      setPixabayVideos(videos);
      // Sélectionner par défaut les 3 premières
      setSelectedVideos(videos.slice(0, 3).map(v => v.url));
      setStep('select');
    } catch (err) {
      setError("Erreur lors de la recherche de vidéos Pixabay.\n" + (err?.message || ''));
    } finally {
      setIsLoading(false);
    }
  };

  // 3. Sélectionner les vidéos à inclure
  const handleVideoSelect = (url) => {
    setSelectedVideos((prev) =>
      prev.includes(url) ? prev.filter((u) => u !== url) : [...prev, url]
    );
  };

  // 4. Générer la vidéo finale à partir du script et de la sélection
  const handleGenerateVideo = async () => {
    if (selectedVideos.length === 0) return;
    setIsLoading(true);
    setError("");
    setVideoUrl(null);
    setDescription("");
    setTags([]);
    try {
      const { videoUrl, description, tags } = await videoService.generateVideoFromSelection(script, selectedVideos);
      setVideoUrl(videoUrl);
      setDescription(description);
      setTags(tags);
      setStep('result');
      fetchHistory();
    } catch (err) {
      setError("Erreur lors de la génération de la vidéo finale.\n" + (err?.message || ''));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto py-10 px-4">
      <h1 className="text-2xl font-bold mb-6">Générer une vidéo avec Monia</h1>

      {/* Étape 1 : prompt */}
      {step === 'prompt' && (
        <form onSubmit={handlePromptSubmit} className="mb-8">
          <label htmlFor="prompt" className="block mb-2 font-medium">Texte à transformer en vidéo :</label>
          <textarea
            id="prompt"
            value={prompt}
            onChange={handleChange}
            className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-rose-400 bg-white text-black dark:bg-white dark:text-black"
            rows={4}
            placeholder="Décris ta vidéo ici..."
          />
          <button
            type="submit"
            className="mt-4 px-6 py-2 rounded-full bg-rose-500 text-white font-semibold hover:bg-rose-600 transition-colors"
            disabled={isLoading || !prompt}
          >
            Générer le script
          </button>
        </form>
      )}

      {/* Étape 2 : affichage du script généré */}
      {step === 'script' && (
        <div className="space-y-4 mb-8">
          {/* Titre TikTok viral, copiable */}
          {tiktokTitle && (
            <div className="flex items-center gap-2 mb-2">
              <span className="text-xl font-bold text-rose-700 cursor-pointer" onClick={() => {navigator.clipboard.writeText(tiktokTitle); setCopiedTag(tiktokTitle); setTimeout(() => setCopiedTag(null), 1200);}} title="Copier le titre TikTok">{tiktokTitle}</span>
              <button
                className="px-2 py-1 bg-slate-200 text-xs rounded hover:bg-slate-300"
                onClick={() => {
                  navigator.clipboard.writeText(tiktokTitle);
                  setCopiedTag(tiktokTitle);
                  setTimeout(() => setCopiedTag(null), 1200);
                }}
                type="button"
                title="Copier le titre TikTok"
              >
                {copiedTag === tiktokTitle ? "Copié !" : "Copier le titre"}
              </button>
            </div>
          )}
          {/* Sujet (sous le titre) */}
          {subject && (
            <div className="flex items-center gap-2 mb-2">
              <span className="text-lg font-semibold text-rose-600">{subject}</span>
              <button
                className="px-2 py-1 bg-slate-200 text-xs rounded hover:bg-slate-300"
                onClick={() => {
                  navigator.clipboard.writeText(subject);
                  setCopiedTag(subject);
                  setTimeout(() => setCopiedTag(null), 1200);
                }}
                type="button"
                title="Copier le sujet"
              >
                {copiedTag === subject ? "Copié !" : "Copier le sujet"}
              </button>
            </div>
          )}
          <div className="bg-gray-100 dark:bg-gray-800 p-3 rounded">
            <div className="whitespace-pre-line text-black dark:text-black">{script}</div>
          </div>
          {/* Zone de tags cliquables */}
          {tags.length > 0 && (
            <div className="mt-2 flex flex-wrap gap-2">
              {tags.map(tag => (
                <button
                  key={tag}
                  className={`px-2 py-1 bg-rose-100 text-rose-700 rounded-full text-xs flex items-center gap-1 hover:bg-rose-200 transition-colors ${copiedTag === tag ? 'ring-2 ring-rose-400' : ''}`}
                  onClick={() => {
                    navigator.clipboard.writeText(tag);
                    setCopiedTag(tag);
                    setTimeout(() => setCopiedTag(null), 1200);
                  }}
                  type="button"
                  title="Copier le tag"
                >
                  #{tag} {copiedTag === tag && <span className="ml-1 text-rose-500">✔</span>}
                </button>
              ))}
            </div>
          )}
          {/* Prompt pour ChatGPT (si besoin de reformuler) */}
          {gptPrompt && (
            <div className="mt-4 p-2 bg-yellow-50 border border-yellow-200 rounded text-xs text-gray-700">
              <div className="font-semibold mb-1">Prompt à coller dans ChatGPT pour un script parfait :</div>
              <textarea className="w-full p-2 rounded border text-xs" rows={4} value={gptPrompt} readOnly />
              <button className="mt-1 px-2 py-1 rounded bg-slate-200 text-xs hover:bg-slate-300" onClick={() => {navigator.clipboard.writeText(gptPrompt); setCopiedTag('prompt'); setTimeout(() => setCopiedTag(null), 1200);}}>
                {copiedTag === 'prompt' ? 'Copié !' : 'Copier le prompt'}
              </button>
            </div>
          )}
          {/* Bouton pour afficher les suggestions vidéo */}
          <button className="btn-primary mt-4" onClick={handleScriptConfirm} disabled={isLoading}>Trouver des vidéos</button>
        </div>
      )}


      {/* Étape 3 : sélection des vidéos Pixabay */}
      {step === 'select' && (
        <div className="space-y-4 mb-8">
          <div className="font-bold mb-2">Vidéos suggérées (3 sélectionnées par défaut) :</div>
          <div className="grid grid-cols-3 gap-4">
            {pixabayVideos.map((vid, idx) => (
              <div
                key={vid.url}
                className={`border-4 rounded-lg p-1 cursor-pointer transition-all duration-200 ${selectedVideos.includes(vid.url) ? 'border-rose-500 ring-4 ring-rose-400' : 'border-gray-200'}`}
                onClick={() => handleVideoSelect(vid.url)}
                tabIndex={0}
                role="button"
                aria-pressed={selectedVideos.includes(vid.url)}
                onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') handleVideoSelect(vid.url); }}
              >
                <video src={vid.preview} controls className="w-full h-32 object-cover rounded" muted>
                  <track kind="captions" />
                </video>
              </div>
            ))}
          </div>
          <div className="text-xs text-gray-500 mt-2">Le montage final sera sans son.</div>
          <button className="btn-primary mt-4" onClick={handleGenerateVideo} disabled={isLoading || selectedVideos.length < 3}>Générer la vidéo finale</button>
        </div>
      )}

      {/* Étape 4 : résultat final */}
      {step === 'result' && videoUrl && !isLoading && (
        <div className="mb-8 flex flex-col items-center">
          <video src={videoUrl} controls className="w-full max-w-md rounded-lg shadow-lg mb-4">
            <track kind="captions" label="Français" />
          </video>
          <div className="flex gap-4">
            <a href={videoUrl} download className="px-4 py-2 rounded-full bg-green-500 text-white font-semibold hover:bg-green-600 transition-colors">Télécharger</a>
            <button onClick={() => setVideoUrl(null)} className="px-4 py-2 rounded-full bg-red-500 text-white font-semibold hover:bg-red-600 transition-colors">Supprimer</button>
          </div>
          {/* Description conseillée et tags dynamiques */}
          <div className="mb-8 w-full max-w-md mx-auto">
            {description && (
              <div className="mb-4">
                <label htmlFor="description" className="block font-semibold mb-1">Description conseillée :</label>
                <textarea
                  className="w-full p-2 border rounded-lg bg-gray-50 text-gray-800 text-sm"
                  rows={3}
                  value={description}
                  readOnly
                />
                <button
                  className="mt-2 px-3 py-1 rounded bg-slate-200 text-xs hover:bg-slate-300"
                  onClick={() => {
                    navigator.clipboard.writeText(description);
                    setCopiedDesc(true);
                    setTimeout(() => setCopiedDesc(false), 1200);
                  }}
                >
                  {copiedDesc ? "Copié !" : "Copier"}
                </button>
              </div>
            )}
            {tags.length > 0 && (
              <div>
                <label htmlFor="tags-list" className="block font-semibold mb-1">Tags suggérés :</label>
                <div className="flex flex-wrap gap-2">
                  {tags.map(tag => (
                    <button
                      key={tag}
                      className={`px-2 py-1 bg-rose-100 text-rose-700 rounded-full text-xs flex items-center gap-1 hover:bg-rose-200 transition-colors ${copiedTag === tag ? 'ring-2 ring-rose-400' : ''}`}
                      onClick={() => {
                        navigator.clipboard.writeText(tag);
                        setCopiedTag(tag);
                        setTimeout(() => setCopiedTag(null), 1200);
                      }}
                      type="button"
                      title="Copier le tag"
                    >
                      #{tag} {copiedTag === tag && <span className="ml-1 text-rose-500">✔</span>}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {/* Historique des vidéos générées */}
      <div className="mt-12">
        <h2 className="text-xl font-bold mb-4">Historique des vidéos générées</h2>
        {(() => {
          if (loadingHistory) {
            return <div className="text-gray-500">Chargement de l’historique…</div>;
          }
          if (history.length === 0) {
            return <div className="text-gray-400">Aucune vidéo générée pour l’instant.</div>;
          }
          return (
            <div className="flex flex-col gap-8">
              {history.map((video) => (
                <div key={video.id} className="border rounded-lg p-4 flex flex-col md:flex-row gap-4 items-center bg-white/80 dark:bg-gray-900/80 shadow">
                  <video
                    src={video.video_url}
                    controls
                    className="w-[180px] h-[320px] rounded-lg shadow-lg object-cover bg-black"
                    style={{ aspectRatio: '9/16', maxHeight: 320 }}
                  >
                    <track kind="captions" label="Français" />
                  </video>
                  <div className="flex-1 w-full">
                    <div className="mb-2 text-xs text-gray-500">{new Date(video.created_at).toLocaleString()}</div>
                    <div className="mb-2">
                      <span className="font-semibold">Prompt :</span> <span className="text-gray-700">{video.prompt}</span>
                    </div>
                    <div className="mb-2 flex items-center gap-2">
                      <span className="font-semibold">Description :</span>
                      <input
                        id="description"
                        className="bg-white text-black px-2 py-1 rounded text-sm border border-gray-200 w-auto max-w-xs dark:bg-white dark:text-black"
                        value={video.description}
                        readOnly
                        style={{ minWidth: 80 }}
                      />
                      <button
                        className="px-2 py-1 rounded bg-slate-200 text-xs hover:bg-slate-300"
                        onClick={() => handleCopyDesc(video.id, video.description)}
                      >
                        {copiedHistory[video.id + '-desc'] ? 'Copié !' : 'Copier'}
                      </button>
                    </div>
                    {Array.isArray(video.tags) && video.tags.length > 0 && (
                      <div className="mb-2">
                        <span className="font-semibold">Tags :</span>
                        <div id="tags-list" className="flex flex-wrap gap-2 mt-1">
                          {video.tags.map((tag) => (
                            <button
                              key={tag}
                              className={`px-2 py-1 bg-rose-100 text-rose-700 rounded-full text-xs flex items-center gap-1 hover:bg-rose-200 transition-colors ${copiedHistory[video.id + '-tag-' + tag] ? 'ring-2 ring-rose-400' : ''} dark:bg-rose-100 dark:text-rose-700`}
                              onClick={() => handleCopyTag(video.id, tag)}
                              type="button"
                              title="Copier le tag"
                            >
                              #{tag} {copiedHistory[video.id + '-tag-' + tag] && <span className="ml-1 text-rose-500">✔</span>}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}
                    <div className="flex gap-3 mt-2">
                      <a
                        href={video.video_url}
                        download
                        className="px-4 py-2 rounded-full bg-green-500 text-white font-semibold hover:bg-green-600 transition-colors"
                      >
                        Télécharger
                      </a>
                      <button
                        className="px-4 py-2 rounded-full bg-red-500 text-white font-semibold hover:bg-red-600 transition-colors"
                        onClick={async () => {
                          if (typeof window !== 'undefined' && window.confirm('Supprimer cette vidéo ?')) {
                            await videoService.deleteVideo(video.id);
                            fetchHistory();
                          }
                        }}
                      >
                        Supprimer
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          );
        })()}
      </div>
    </div>
  );
};

export default Monia;
